import { Box, Button, Flex, Text } from "@chakra-ui/react";

// Inline banner shown above the map during manual draw mode (P6.6). NOT a
// TopBar replacement — Zillow leaves their filter pills visible above the
// banner and we do too. The banner just covers the top strip of the map
// pane with instructions and the Cancelar / Aplicar actions.
//
// Positioned absolutely by its parent (MapPane) inside the position:
// relative outer Box, spanning the full map width and sitting at top=0.
//
// Aplicar is visually disabled until the polygon has ≥3 vertices. We
// prefer explicit disabled state over a silent no-op (per the P6.6 spec):
// users get a clearer affordance when there's not enough to commit.
const DrawBanner = ({ canApply, onCancel, onApply }) => (
    <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        zIndex={10}
        bg="white"
        borderBottomWidth="1px"
        borderColor="gray.200"
        boxShadow="sm"
        px={4}
        py={3}
    >
        {/* Stack vertically on narrow screens — text on its own row above
            the action buttons. At md+, everything lives on one row with
            text on the left and buttons right-aligned. The inner Flex
            around the buttons keeps them paired together either way. */}
        <Flex
            direction={{ base: "column", md: "row" }}
            align={{ base: "stretch", md: "center" }}
            gap={{ base: 2, md: 3 }}
        >
            <Text fontSize="sm" color="gray.700" flex="1 1 auto">
                <Text as="span" fontWeight="600">
                    Dibuja un perímetro
                </Text>{" "}
                alrededor de la región
            </Text>
            <Flex gap={2} justify="flex-end">
                <Button
                    onClick={onCancel}
                    variant="ghost"
                    size="sm"
                    px={5}
                    borderRadius="md"
                    color="gray.600"
                >
                    Cancelar
                </Button>
                <Button
                    onClick={onApply}
                    size="sm"
                    px={6}
                    borderRadius="md"
                    bg="colorPalette.solid"
                    color="white"
                    disabled={!canApply}
                    _disabled={{ opacity: 0.4, cursor: "not-allowed" }}
                    _hover={!canApply ? {} : { bg: "colorPalette.emphasized" }}
                >
                    Aplicar
                </Button>
            </Flex>
        </Flex>
    </Box>
);

export default DrawBanner;
